import styled from "styled-components";

export const Container = styled("div")(({ theme }) => ({
    padding: `${theme.spacing.medium} ${theme.spacing.medium}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.colors[theme.colorMode].positive,
    borderRadius: theme.spacing.small,
    cursor: "pointer",
}));
